
import { defineComponent } from "vue";
import api, { SecurityEventList, SecurityEvent, RequestPaging, RequestSort, PageBounding }  from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: SecurityEventList;
  requestFilter: SecurityEvent;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
}

export default defineComponent({
  name: "SheqsyEvent",
  mounted() {
    this.$nextTick(() => {
      this.processQueryParams();
      this.getList();
    });
  },
  data: (): State => {
    const event_list = { } as SecurityEventList;
    const event_struct = { } as SecurityEvent;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    return {
      msg: "Sheqsy Security Events",
      backendResponse: event_list,
      requestFilter: event_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDate,
    processQueryParams() {
      if ('f.EmployeeUId' in this.$route.query && typeof(this.$route.query['f.EmployeeUId']) == 'string') {
        this.requestFilter.EmployeeUId = this.$route.query['f.EmployeeUId']
      }
      if ('f.ActivityUId' in this.$route.query && typeof(this.$route.query['f.ActivityUId']) == 'string') {
        this.requestFilter.ActivityUId = this.$route.query['f.ActivityUId']
      }
    },
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as SecurityEvent;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse = { } as SecurityEventList;
      this.$router.push({query: {'f.EmployeeUId': this.requestFilter.EmployeeUId, 'f.ActivityUId': this.requestFilter.ActivityUId}})
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getSecurityEventList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
